t<template>
  <div>
    <AppLoading v-if="isLoading" />
    <Terms :editable="editable" @selectTerm="onSelectTerm">
      <template #config>
        <!-- This has to have a type check, as default value is Symbol,
        which causes type error because of Vue's prop check. -->
        <div class="row">
          <TermSelect
            label="Current Active Term "
            :value="typeof currentTerm === 'object' ? currentTerm : {}"
            :terms="terms"
            :disabled="!editable"
            class="col-6 col-xl-4 px-0"
            @input="$store.dispatch('setCurrentTerm', { ...$event, forceReload: true })"
          />
        </div>
      </template>
    </Terms>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
// eslint-disable-next-line
import Terms from '@sm/client/components/Terms/Terms'
// eslint-disable-next-line
import TermSelect from '@sm/client/components/Terms/TermSelect'

export default {
  components: {
    Terms, TermSelect,
  },
  computed: {
    ...mapState({ currentTerm: state => state.general.terms.currentTerm }),
    ...mapGetters([ 'school', 'terms' ]),
    editable () {
      return this.$hasAccess().to('emSettings').to('editTerms').value()
    },
    isLoading () {
      // TODO: Cannot have `terms` in loading, as it's a getter that returns [], so no way to check loading state.
      // At some point have a separate flag for it.
      return this.currentTerm === Symbol.for('default')
    },
  },
  created () {
    this.$store.dispatch('loadTerms', { school: this.school, filterHistorical: false, forceReload: true })
    if (this.currentTerm === Symbol.for('default')) this.$store.dispatch('loadCurrentTerm', { school: this.school })
  },
  methods: {
    onSelectTerm (term) {
      this.$router.push({ name: 'emTermSettings', params: { termId: term.id } })
    },
  },
}
</script>
